// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_1Lck3","status":"index_status_XJHyO","footer":"index_footer_3yBLV"};